import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import shortid from 'shortid';

class RadioFormInput extends Component {
  static propTypes = {
    // Required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedOption: PropTypes.string.isRequired,

    //Optional
    errorMessage: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    selectOptions: PropTypes.array,
    children: PropTypes.object,
    showError: PropTypes.bool,
  }

  renderLabel(label) {
    return label
    ? (
        <label>{label}</label>
      )
    : ''
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : '';
  }

  render() {
    const {
      selectedOption,
      errorMessage,
      showError,
      onChange,
      label,
      name,
      optionalClasses,
      options
    } = this.props;

    return (
      <div
        className={`radio-form-input${optionalClasses ? ' ' + optionalClasses : ''}${showError && errorMessage ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        {
          options.map((option) => {
            let optionId = shortid.generate();
            return (
              <div className="radio-container" key={optionId}>
                <input
                  id={optionId}
                  name={name}
                  type="radio"
                  value={option.value}
                  onChange={onChange}
                  checked={selectedOption === option.value}
                />
                <label htmlFor={optionId} >
                  {option.label}
                </label>
              </div>
            );
          })
        }
        {showError && this.renderErrorMessage(errorMessage)}
      </div>
    )
  }
}


export default RadioFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/RadioFormInput.js